import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/blog/components/BlogIndexContent.tsx");
